export default "__VITE_ASSET__MnpnXBHC__"